import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import OperationButton from 'components/OperationButton';

export default class Pagination extends Component {
  static propTypes = {
    data: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
      totalEntries: PropTypes.number.isRequired,
    }).isRequired,
    handlePageChange: PropTypes.func.isRequired,
  };

  getPageNumbers() {
    const { data } = this.props;
    const { currentPage, totalPages } = data;
    const range = 2; // Numero di pagine da mostrare prima e dopo quella attuale

    const pages = [];
    if (totalPages <= 5) {
      // Mostra tutte le pagine se sono poche
      for (let i = 1; i <= totalPages; i += 1) {
        pages.push(i);
      }
    } else {
      // Aggiungi la prima pagina
      pages.push(1);

      // Aggiungi puntini se necessario
      if (currentPage > range + 2) {
        pages.push('...');
      }

      // Aggiungi le pagine intorno a quella attuale
      for (
        let i = Math.max(2, currentPage - range);
        i <= Math.min(totalPages - 1, currentPage + range);
        i += 1
      ) {
        pages.push(i);
      }

      // Aggiungi puntini se necessario
      if (currentPage < totalPages - range - 1) {
        pages.push('...');
      }

      // Aggiungi l'ultima pagina
      pages.push(totalPages);
    }

    return pages;
  }

  render() {
    const { handlePageChange, data } = this.props;
    const { currentPage, totalPages } = data;
    const pageNumbers = this.getPageNumbers();

    return (
      <div>
        { totalPages && totalPages > 1 &&
          <div className="Pagination">
            {/* Pulsante "Previous" */}
            <OperationButton
              onClick={() => handlePageChange(currentPage - 1)}
              className="button button--tiny"
              label={['Previous']}
              disabled={currentPage === 1}
            />

            {/* Numeri di pagina */}
            {pageNumbers.map((page) => {
              // Non usare l'indice per le chiavi, ma un identificatore univoco
              if (page === '...') {
                return (
                  <span
                    key={`dots-${currentPage}`}
                    className="pagination__dots"
                  >
                    ...
                  </span>
                );
              }

              return (
                <OperationButton
                  key={`page-${page}`}
                  onClick={() => handlePageChange(page)}
                  className={`button button--tiny ${
                    currentPage === page ? 'button--secondary' : ''
                  }`}
                  label={[String(page)]}
                />
              );
            })}

            {/* Pulsante "Next" */}
            <OperationButton
              onClick={() => handlePageChange(currentPage + 1)}
              className="button button--tiny"
              label={['Next']}
              disabled={currentPage === totalPages}
            />
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Pagination.jsx